const SvgNavigationBack = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24">
    <path fill="#373737" fillRule="evenodd" d="m22 10.002-.706.706-8.793-8.794.041 22.084-.998.002-.041-22.09-8.797 8.798L2 10.002 12 0z" clipRule="evenodd" />
  </svg>;
export default SvgNavigationBack;